package com.partejar.app.feature.home.presentation

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.partejar.app.feature.home.data.HomeDataSource
import com.partejar.app.feature.home.data.HomeSessionExpiredException
import com.partejar.app.feature.home.data.HomeWorkspaceForbiddenException
import com.partejar.app.feature.home.data.HomeWorkspaceNotConfiguredException
import kotlinx.coroutines.CancellationException
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

class HomeViewModel private constructor(
    private val dataSource: HomeDataSource,
    private val loadingScope: CoroutineScope?,
    @Suppress("UNUSED_PARAMETER") testableConstructor: Unit
) : ViewModel() {
    constructor(dataSource: HomeDataSource) : this(dataSource, null, Unit)

    internal constructor(
        dataSource: HomeDataSource,
        loadingScope: CoroutineScope
    ) : this(dataSource, loadingScope, Unit)

    private val _uiState = MutableStateFlow<HomeUiState>(HomeUiState.Loading)
    val uiState: StateFlow<HomeUiState> = _uiState.asStateFlow()

    init {
        loadHome()
    }

    fun retry() = loadHome()

    private fun loadHome() {
        _uiState.value = HomeUiState.Loading
        (loadingScope ?: viewModelScope).launch {
            _uiState.value = try {
                HomeUiStateFactory.create(dataSource.loadHome())
            } catch (error: CancellationException) {
                throw error
            } catch (error: Throwable) {
                HomeUiState.Error(error.userMessage())
            }
        }
    }
}

private fun Throwable.userMessage(): String = when (this) {
    is HomeSessionExpiredException -> "Sua sessão expirou. Entre novamente."
    is HomeWorkspaceNotConfiguredException -> "Não foi possível identificar o workspace atual."
    is HomeWorkspaceForbiddenException -> "Você não tem acesso ao workspace selecionado."
    else -> "Não foi possível carregar sua Home."
}
